import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  message: "",
  quantities: {},
};

const CartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    message(state) {
      state.message = "thank you";
    },
    clearMessage(state) {
      state.message = "";
    },
  },
});

export const { message, clearMessage } = CartSlice.actions;
export default CartSlice.reducer;
